"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CommercialHero() {
  return <section data-section-id="515" id="commercialhero" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/plumbing_service_hero.png" alt="Professional technician inspecting a commercial pump system" loading="eager" decoding="async" className="h-full w-full object-cover animate-[kenburns_20s_ease-in-out_infinite_alternate]" />
      </div>

      <div className="absolute inset-0 z-10" style={{
      background: "linear-gradient(to bottom, hsla(220, 95%, 10%, 0.85) 0%, hsla(220, 95%, 10%, 0.65) 45%, hsla(220, 95%, 10%, 0.9) 100%)"
    }} />

      <div className="relative z-20 mx-auto flex min-h-screen w-full max-w-7xl flex-col px-6 pt-32 pb-24 md:px-10 lg:px-16">
        <div className="flex flex-1 items-center">
          <div className="max-w-4xl">
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-accent" />
              <span className="font-default text-xs tracking-[0.25em] uppercase text-white font-bold">
                Commercial Plumbing Services / Miami & South Florida
              </span>
            </div>

            <h1 className="font-default font-bold leading-[0.95] tracking-tight text-white mb-6" style={{
            fontSize: "clamp(3.5rem, 10vw, 6.5rem)"
          }}>
              Fire Pumps & <br />
              <span className="text-accent">Heat Exchangers</span>
            </h1>

            <p className="mt-8 max-w-2xl font-default text-lg leading-relaxed md:text-xl text-white/90">
              Fire pumps sit unused for long stretches and can fail quietly without regular testing. Heat exchangers build scale and corrosion over time, losing efficiency long before anyone notices. Skipped inspections turn into compliance issues, costly repairs, or worse.
            </p>

            <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="https://aaeagleplumbing.com/contact/" className="inline-flex items-center justify-center bg-accent text-black hover:bg-accent-hover active:bg-accent-active hover:-translate-y-1 active:translate-y-0 hover:scale-105 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring px-10 py-5 text-base md:text-lg font-semibold rounded-lg text-center">
                Contact Us Now
              </Link>
              <span className="font-default text-white/90 ml-2 font-semibold">
                Or call us at{" "}
                <a href="tel:3055613895" className="text-accent hover:underline hover:opacity-80 transition-all">
                  305-561-3895
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className="relative mt-auto flex items-end justify-between pt-12">
          <div className="flex flex-col items-center gap-3">
            <span className="font-default text-[10px] tracking-[0.4em] uppercase text-white/70" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Scroll
            </span>
            <div className="relative h-16 w-px overflow-hidden">
              <div className="absolute inset-0 animate-[scrollLine_2s_ease-in-out_infinite] bg-white/60" />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes kenburns { 0% { transform: scale(1) translate(0, 0); } 100% { transform: scale(1.12) translate(-1%, -1%); } }
        @keyframes scrollLine { 0% { transform: translateY(-100%); } 100% { transform: translateY(100%); } }
      `}</style>
    </section>;
}